import ProjectSettingsModal from './ProjectSettingsModal';

export default ProjectSettingsModal;
